import React from 'react';
import ReactDOM from 'react-dom';

import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import { Provider } from "react-redux";
import thunk from "redux-thunk";

import { HashRouter as Router } from 'react-router-dom';

//to make things work in ie11, need these.... (at the moment these work and we have no need for polyfill!!!)
//NOTE: we do not support ie11 in ie10 document mode
import 'core-js/es6/array'; //array.find()
import 'core-js/es7/array'; //array.includes()
import 'core-js/es6/string'; //.startsWith
import "core-js/fn/symbol/iterator.js"; // symbol iterator for file upload
import 'core-js/es6/symbol'; // built in symbol type - needed for prime react
//end ie stuff

import App from './container/App.js'

import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css'

/*NOTE: this overrides the component css*/
/*e.g. if this import line was placed in payment-step-payee.js instead of here
* the css override will not be applied because the import for 'primereact.min.css' and 'themes/omega/theme.css'
* overrides it
* so css seems to be loaded in component -> container order
*/
import './css/primereact-accordion-app.css';
import './css/primereact-autocomplete-app.css';
import './css/primereact-inputtext-app.css';
import './css/primereact-inputtextarea-app.css';
import './css/primereact-button-app.css';
import './css/primereact-checkbox-app.css';
import './css/primereact-panel-app.css';
import './css/primereact-datatable-app.css';
import './css/primereact-dialog-app.css';
import './css/primereact-dropdown-app.css';
import './css/primereact-message-app.css';
import './css/primereact-sidebar.css';
import './css/primereact-fileupload-app.css';

//import reducers...
import appReducer from "./reducers/app";
import annualReturnClientReducer from "./reducers/annualReturnClient";
import annualReturnEmployeeReducer from "./reducers/annualReturnEmployee";
import authReducer from "./reducers/auth";
import lobbyistReducer from "./reducers/lobbyist";
import clientReducer from "./reducers/client";
import employeeReducer from "./reducers/employee";
import annualReturnReducer from "./reducers/annualReturn";
import lookupCodeReducer from "./reducers/lookupCode";
import systemParameterReducer from "./reducers/systemParameter";
import auditLogReducer from "./reducers/auditLog";
import ReactGA from 'react-ga';

import { axiosSetup } from './js/axios.js'

import { createBrowserHistory } from 'history';
import ReactAI from 'react-appinsights';

// create history here and passthrough to router component so it can used in app insight tracking
const history = createBrowserHistory()
if (process.env.REACT_APP_IS_DEV === false) {
  ReactAI.init({ instrumentationKey: process.env.REACT_APP_INSIGHT_KEY }, history)
}

// OLD: UA-136875555-1
ReactGA.initialize('UA-132418771-1');
history.listen(function(location){
   ReactGA.pageview(location.pathname + location.hash + location.search);
});

// combine the reducers. This will build up the structure of what the store in redux will look like.
let reducers = combineReducers({ 
  app: appReducer, annualReturnClient: annualReturnClientReducer, annualReturnEmployee: annualReturnEmployeeReducer, auth: authReducer, client: clientReducer, 
  lobbyist: lobbyistReducer, employee: employeeReducer, annualReturn: annualReturnReducer, lookupCode: lookupCodeReducer, systemParameter: systemParameterReducer,
  auditLog: auditLogReducer
});
let composeEnhancers = compose // window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; //to use redux dev tools or just the default compose if no __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ exists
let store = createStore(reducers, /* preloadedState, */ composeEnhancers(
  applyMiddleware(thunk)
));

// set up axios global object so we can create things such as interceptors to do things things every request like adding an authorisation token
axiosSetup(store)

ReactDOM.render(
  <Provider store={store} history={history}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js